module.exports = __webpack_public_path__ + "media/images/projects/6-header-709aae244c711c68a4d35bd23c00d08c.jpg";